/**
 * App chrome, Malayalam. Mirrors every key in `../en/common.ts`.
 *
 * Two deliberate non-translations: "KYC" and "Pay" stay as they are, because
 * both are what Kerala savers actually say and read on every other banking app
 * they use — a transliteration would be less recognisable, not more local.
 */
export default {
  // Bottom tab bar
  'nav.home': 'ഹോം',
  'nav.schemes': 'പദ്ധതികൾ',
  'nav.pay': 'അടയ്ക്കുക',
  'nav.ledger': 'ലെഡ്ജർ',
  'nav.account': 'അക്കൗണ്ട്',

  // Top app bar
  'header.notifications': 'അറിയിപ്പുകൾ',
  'header.notificationsUnread': 'അറിയിപ്പുകൾ, {{count}} വായിക്കാത്തവ',
  'header.back': 'തിരികെ പോകുക',
  'header.theme.toLight': 'ലൈറ്റ് തീമിലേക്ക് മാറുക',
  'header.theme.toDark': 'ഡാർക്ക് തീമിലേക്ക് മാറുക',
  'header.language': 'ഭാഷ',
  'header.language.en': 'ഇംഗ്ലീഷ്',
  'header.language.ml': 'മലയാളം',

  // Home quick actions
  'quickActions.goals': 'ലക്ഷ്യങ്ങൾ',
  'quickActions.redeem': 'റിഡീം',
  'quickActions.loans': 'വായ്പകൾ',
  'quickActions.complaints': 'പരാതികൾ',

  // Account menu + the page titles those rows lead to
  'account.profile': 'പ്രൊഫൈലും KYC-യും',
  'account.ledger': 'അക്കൗണ്ട് ലെഡ്ജർ',
  'account.goals': 'ലക്ഷ്യങ്ങളും നാഴികക്കല്ലുകളും',
  'account.payments': 'പേയ്‌മെന്റ് ചരിത്രം',
  'account.redemptions': 'റിഡംപ്ഷനുകൾ',
  'account.loans': 'ആഭരണ വായ്പകൾ',
  'account.complaints': 'പരാതികളും പിന്തുണയും',
  'account.notifications': 'അറിയിപ്പുകൾ',
  'account.settings': 'ക്രമീകരണങ്ങൾ',
  'account.help': 'സഹായവും പിന്തുണയും',

  // Page titles that are not account-menu rows
  'page.pay': 'അടയ്ക്കുക',
  'page.spin': 'സ്പിൻ & വിൻ',
  'page.spinGold': 'ഗോൾഡ് സേവർ സ്പിൻ'
};
